import React, { createContext, useContext, useReducer } from "react";

//
// 1) Definer global state-typen
//
export type AppState = {
  email: string | null;
  tenantId: string | null;

  authMe: any | null;
  user: any | null;
  owner: any | null;
  rates: any | null;

  isLoggedIn: boolean;
};

//
// 2) Initial state
//
const initialState: AppState = {
  email: null,
  tenantId: localStorage.getItem("tenantId"),

  authMe: null,
  user: null,
  owner: null,
  rates: null,

  isLoggedIn: false,
};

//
// 3) Actions
//
type Action =
  | { type: "SET_EMAIL"; payload: string | null }
  | { type: "SET_TENANT"; payload: string | null }
  | { type: "SET_AUTH_ME"; payload: any | null }
  | { type: "SET_USER"; payload: any | null }
  | { type: "SET_OWNER"; payload: any | null }
  | { type: "SET_RATES"; payload: any | null }
  | { type: "SET_LOGGED_IN"; payload: boolean }
  | { type: "RESET_TENANT_STATE" };

//
// 4) Reducer
//
function reducer(state: AppState, action: Action): AppState {
  switch (action.type) {
    case "SET_EMAIL":
      return { ...state, email: action.payload };

    case "SET_TENANT":
      if (action.payload) localStorage.setItem("tenantId", action.payload);
      else localStorage.removeItem("tenantId");
      return { ...state, tenantId: action.payload };

    case "SET_AUTH_ME":
      return { ...state, authMe: action.payload };

    case "SET_USER":
      return { ...state, user: action.payload };

    case "SET_OWNER":
      return { ...state, owner: action.payload };

    case "SET_RATES":
      return { ...state, rates: action.payload };

    case "SET_LOGGED_IN":
      return { ...state, isLoggedIn: action.payload };

    // Viktig: når tenant byttes
    case "RESET_TENANT_STATE":
      return {
        ...state,
        authMe: null,
        user: null,
        owner: null,
        rates: null,
      };

    default:
      return state;
  }
}

//
// 5) Context-provider
//
const AppStateCtx = createContext<AppState | undefined>(undefined);
const AppDispatchCtx = createContext<React.Dispatch<Action> | undefined>(
  undefined
);

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppStateCtx.Provider value={state}>
      <AppDispatchCtx.Provider value={dispatch}>
        {children}
      </AppDispatchCtx.Provider>
    </AppStateCtx.Provider>
  );
};

//
// 6) Hooks
//
export const useAppState = () => {
  const ctx = useContext(AppStateCtx);
  if (!ctx) throw new Error("useAppState må brukes i AppProvider");
  return ctx;
};

export const useAppDispatch = () => {
  const ctx = useContext(AppDispatchCtx);
  if (!ctx) throw new Error("useAppDispatch må brukes i AppProvider");
  return ctx;
};
